import {WhitespaceValidator} from '@spa/validators';

import {AmountControl, BaseControl, SelectControl} from 'appShared/classes';
import {ComponentTypesEnum} from 'appShared/enums';
import {DialogButtonTypesEnum, DialogConfigInterface} from 'appShared/components';
import {Validators} from '@angular/forms';
import {NasdaqReportMapsEnum} from '@spa/api';
import {
    AddNewFeedNasdaqReportMapName,
    AddNewFeedProductCodeForNonProName,
    AddNewFeedProductCodeForProName,
    AddNewFeedReportTitleIdForNonProName,
    AddNewFeedReportTitleIdForProName,
    REPORT_MAP_KEY_MAX_LENGTH
} from 'appAssets/selectors';

export const AddNewFeedNameSelector = 'addNewFeedName';
export const AddNewFeedDescriptionSelector = 'addNewFeedDescription';
export const AddNewFeedMarketSelector = 'addNewFeedMarket';
export const AddNewFeedCostToAlaricProSelector = 'addNewFeedCostToAlaricPro';
export const AddNewFeedCostToAlaricNonProSelector = 'addNewFeedCostToAlaricNonPro';
export const AddNewFeedIndividualPriceProSelector = 'addNewFeedIndividualPricePro';
export const AddNewFeedIndividualPriceNonProSelector = 'addNewFeedIndividualPriceNonPro';
export const AddNewFeedAlaricInternalPriceSelector = 'addNewFeedAlaricInternalPrice';
export const AddNewFeedCurrencySelector = 'addNewFeedCurrency';
export const AddNewFeedHasL1Selector = 'addNewFeedHasL1';
export const AddNewFeedHasL2Selector = 'addNewFeedHasL2';
export const AddNewFeedL2SuffixesSelector = 'addNewFeedL2Suffixes';
export const AddNewFeedBBOSuffixesSelector = 'addNewFeedBBOSuffixes';
export const AddNewFeedNBBOSuffixesSelector = 'addNewFeedNBBOSuffixes';
export const AddNewFeedFxSuffixesSelector = 'AddNewFeedFxSuffixes';
export const AddNewFeedAfxSuffixesSelector = 'AddNewFeedAfxSuffixes';
export const AddNewFeedTseSuffixesSelector = 'AddNewFeedTseSuffixes';
export const AddNewFeedCfdSuffixesSelector = 'AddNewFeedCfdSuffixes';
export const AddNewFeedOc5SuffixesSelector = 'AddNewFeedOc5Suffixes';
export const AddNewFeedCboeOneSuffixesSelector = 'AddNewFeedCboeOneSuffixes';
export const AddNewFeedExcludeSuffixesSelector = 'addNewFeedExcludeSuffixes';
export const AddNewFeedTradeSuffixesSelector = 'addNewFeedTradeSuffixes';
export const AddNewFeedImbalanceSuffixesSelector = 'addNewFeedImbalanceSuffixes';
export const AddNewFeedPlatformFrontendIdsSelector = 'addNewFeedPlatformFrontendIds';
export const AddNewFeedHasImbalanceSelector = 'addNewFeedHasImbalance';
export const AddNewFeedSuffixPrioritySelector = 'addNewFeedSuffixPriority';
export const AddNewFeedReportNameSelector = 'addNewFeedReportName';
export const AddNewFeedNasdaqReportMapSelector = 'addNewFeedNasdaqReportMap';
export const AddNewFeedProductCodeForProSelector = 'addNewFeedProductCodeForPro';
export const AddNewFeedProductCodeForNonProSelector = 'addNewFeedProductCodeForNonPro';
export const AddNewFeedReportTitleIdForProSelector = 'addNewFeedReportTitleIdForPro';
export const AddNewFeedReportTitleIdForNonProSelector = 'addNewFeedReportTitleIdForNonPro';
export const AddNewFeedExclusionPortalIdsSelector = 'addNewFeedExclusionPortalIds';
export const AddNewFeedXetraSuffixesSelector = 'AddNewFeedXetraSuffixes';
export const AddNewFeedEnxSuffixesSelector = 'AddNewFeedEnxSuffixes';
export const AddNewFeedXetraCoreEtfsSuffixesSelector = 'AddNewFeedXetraCoreEtfsSuffixes';

export const AddNewFeedDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm,
                customText: 'Add Feed'
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false,
        disabledCloseBtn: true
    };
};

export const MarketDataFeedFormControls = (): BaseControl<any>[] => {
    return [
        new BaseControl({
            name: AddNewFeedNameSelector,
            value: '',
            placeholder: 'Name',
            validators: [WhitespaceValidator()],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedDescriptionSelector,
            value: '',
            placeholder: 'Description',
            validators: [WhitespaceValidator()],
            componentType: ComponentTypesEnum.Textarea,
        }),
        new SelectControl({
            name: AddNewFeedMarketSelector,
            value: null,
            placeholder: 'Market',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
        new SelectControl({
            name: AddNewFeedPlatformFrontendIdsSelector,
            value: null,
            placeholder: 'Platform Frontend',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: false,
        }),
        new AmountControl({
            name: AddNewFeedCostToAlaricProSelector,
            value: null,
            placeholder: 'Cost to Alaric (pro)',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        }),
        new AmountControl({
            name: AddNewFeedCostToAlaricNonProSelector,
            value: null,
            placeholder: 'Cost to Alaric (non-pro)',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        }),
        new AmountControl({
            name: AddNewFeedIndividualPriceProSelector,
            value: null,
            placeholder: 'Individual Price (pro)',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        }),
        new AmountControl({
            name: AddNewFeedIndividualPriceNonProSelector,
            value: null,
            placeholder: 'Individual Price (non-pro)',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        }),
        new AmountControl({
            name: AddNewFeedAlaricInternalPriceSelector,
            value: null,
            placeholder: 'Internal Price',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null
        }),
        new BaseControl({
            name: AddNewFeedL2SuffixesSelector,
            value: '',
            placeholder: 'L2 Suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedBBOSuffixesSelector,
            value: '',
            placeholder: 'BBO Suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedNBBOSuffixesSelector,
            value: '',
            placeholder: 'NBBO Suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedExcludeSuffixesSelector,
            value: '',
            placeholder: 'Exclude Suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedTradeSuffixesSelector,
            value: '',
            placeholder: 'Trade Suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedImbalanceSuffixesSelector,
            value: '',
            placeholder: 'Imbalance Suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new SelectControl({
            name: AddNewFeedSuffixPrioritySelector,
            value: null,
            placeholder: 'Suffix Priority',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: false,
        }),
        new BaseControl({
            name: AddNewFeedReportNameSelector,
            value: '',
            placeholder: 'Report Name',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new SelectControl({
            name: AddNewFeedCurrencySelector,
            value: null,
            placeholder: 'Currency',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: false,
        }),
        new BaseControl({
            name: AddNewFeedFxSuffixesSelector,
            value: '',
            placeholder: 'Fx Suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedAfxSuffixesSelector,
            value: '',
            placeholder: 'Afx Suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedCfdSuffixesSelector,
            value: '',
            placeholder: 'Cfd Suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedOc5SuffixesSelector,
            value: '',
            placeholder: 'Options Conflated 5-Sec',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new SelectControl({
            name: AddNewFeedNasdaqReportMapSelector,
            value: null,
            placeholder: AddNewFeedNasdaqReportMapName,
            validators: [Validators.maxLength(REPORT_MAP_KEY_MAX_LENGTH)],
            componentType: ComponentTypesEnum.Select,
            options: [
                {
                    label: AddNewFeedProductCodeForProName,
                    value: NasdaqReportMapsEnum.ProductCodeForPro
                },
                {
                    label: AddNewFeedProductCodeForNonProName,
                    value: NasdaqReportMapsEnum.ProductCodeForNonPro
                },
                {
                    label: AddNewFeedReportTitleIdForProName,
                    value: NasdaqReportMapsEnum.ReportTitleIdForPro
                },
                {
                    label: AddNewFeedReportTitleIdForNonProName,
                    value: NasdaqReportMapsEnum.ReportTitleIdForNonPro
                },
            ],
            multiple: false,
        }),
        new BaseControl({
            name: AddNewFeedProductCodeForProSelector,
            value: '',
            placeholder: AddNewFeedProductCodeForProName,
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedProductCodeForNonProSelector,
            value: '',
            placeholder: AddNewFeedProductCodeForNonProName,
            validators: [Validators.maxLength(REPORT_MAP_KEY_MAX_LENGTH)],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedReportTitleIdForProSelector,
            value: '',
            placeholder: AddNewFeedReportTitleIdForProName,
            validators: [Validators.maxLength(REPORT_MAP_KEY_MAX_LENGTH)],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedReportTitleIdForNonProSelector,
            value: '',
            placeholder: AddNewFeedReportTitleIdForNonProName,
            validators: [Validators.maxLength(REPORT_MAP_KEY_MAX_LENGTH)],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedCboeOneSuffixesSelector,
            value: '',
            placeholder: 'CBOE One Suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new SelectControl({
            name: AddNewFeedExclusionPortalIdsSelector,
            value: null,
            placeholder: 'Exclude Portals',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            multiple: true,
        }),
        new BaseControl({
            name: AddNewFeedTseSuffixesSelector,
            value: '',
            placeholder: 'Tse Suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedXetraSuffixesSelector,
            value: '',
            placeholder: 'Xetra Core L1 suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedEnxSuffixesSelector,
            value: '',
            placeholder: 'Euronext Suffixes',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
        new BaseControl({
            name: AddNewFeedXetraCoreEtfsSuffixesSelector,
            value: '',
            placeholder: 'Xetra Core ETFs and ETPs L1',
            validators: [],
            componentType: ComponentTypesEnum.Text,
        }),
    ];
};
